export const PERMISSION = {
  ADD: 'BANKUSER_ADD',
  EDIT: 'BANKUSER_EDIT',
  VIEW: 'BANKUSER_VIEW',
  DEL: 'BANKUSER_DEL',
};

export const MODAL = {
  IMPORT: 'bw_modal_bank_user_import',
  IMPORT_ERROR: 'bw_modal_bank_user_import_error',
}
